<xemex-card
  [title]="'home.newAlarms.title' | translate"
  titleSize="lg"
  [actionLabel]="'home.viewAll' | translate"
  (action)="viewAll.emit()"
>
  <div class="flex flex-col divide-y divide-border-subtle pt-2">
    @for (alarm of alarms(); track alarm.id) {
      <xemex-list-row
        [title]="alarm.typeLabel"
        [subtitle]="alarm.deviceLdn"
        [clickable]="true"
        (rowClick)="alarmClick.emit(alarm.deviceId)"
      >
        <div listRowLeading class="w-24 flex-none">
          <xemex-tag [state]="alarm.priorityState" [label]="alarm.priorityLabel"></xemex-tag>
        </div>
        <span listRowActions class="text-xs text-muted whitespace-nowrap">{{ alarm.age }}</span>
        <mat-icon listRowActions class="text-muted !text-lg">chevron_right</mat-icon>
      </xemex-list-row>
    } @empty {
      <p class="text-sm text-muted py-2">{{ 'home.newAlarms.empty' | translate }}</p>
    }
  </div>
</xemex-card>
